<template>
    <transition name="alert">
        <div v-if="isShow" class="alert-container">
            <div class="alert-wrap rounded d-flex justify-content-between align-items-center p-2"
                :class="theme === 'light' ? `border ${theme} ${type}` : `${theme} ${type}`">
                <div class="alert-wrap-msg mx-1">{{ msg }}</div>
                <div v-if="!hideOk">
                    <b-link class="btn ml-1 text-primary" @click="onOk">{{ okText }}</b-link>
                </div>
            </div>
        </div>
    </transition>
</template>
   
<script>
export default {
    name: 'Alert',
    props: {
        msg: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: false
        },
        hideOk: {
            type: Boolean,
            default: false
        },
        auto: {
            type: Boolean,
            default: true
        },
        duration: {
            type: Number,
            default: 3000
        },
        type: {
            type: String,
            default: 'info', // info、success、error
        },
        okText: {
            type: String,
            default: 'Okay'
        },
        theme: {
            type: String,
            default: 'dark', // dark、light
        },
    },
    watch: {
        isShow: {
            handler(newVal, oldVal) {
                if (newVal && this.auto) {
                    const _that = this
                    const timer = setTimeout(() => {
                        _that.isShow = false
                        clearTimeout(timer)
                    }, _that.duration)
                }
            }
        }
    },
    methods: {
        onOk() {
            this.isShow = false
        }
    }
}

</script>
<style lang='scss' scoped>
.alert-enter,
.alert-leave-to {
    opacity: 0;
}

.alert-enter-to,
.alert-leave {
    opacity: 1;
}

.alert-enter-active {
    transition: all 0.2s linear;
    animation: appear 0.2s linear 0s;
}

.alert-leave-active {
    transition: all 0.2s linear;
    animation: appear 0.2s linear 0s reverse;
}

@keyframes appear {
    0% {
        transform: translateX(-50%) translateY(0);
    }

    100% {
        transform: translateX(-50%) translateY(-2rem);
    }
}

.alert-container {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) translateY(-2rem);
    max-width: 25%;
    z-index: 10000;

    .alert-wrap.dark {
        background-color: $dark;

        .alert-wrap-msg {
            color: $white;
        }
    }

    .alert-wrap.light {
        background-color: $light;

        .alert-wrap-msg {
            color: $dark;
        }
    }

    .alert-wrap.success {
        .alert-wrap-msg {
            color: $success;
        }
    }

    .alert-wrap.error {
        .alert-wrap-msg {
            color: $danger;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/alert/Alert.vue